module.exports = __webpack_public_path__ + "images/redactie-purple.cf3accdd5fabb9e1484c50303b0ecfcb.svg";